export const DEFAULT_CHECKOUT_TIMEOUT = 600;
export const DEFAULT_IDLE_TIMEOUT = 10;
export const ERROR_STATUS_CODES = [400, 401, 403, 404, 500];
export const CURRENT_USER = 'current';
export const ANONYMOUS_USER = 'anonymous';
export const ORDER_HISTORY_PERIOD = 180;
